import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';

const headCells = [
  /* {
    id: 'funcionario',
    numeric: false,
    disablePadding: false,
    label: 'Funcionário',
  }, */
  {
    id: 'gerente',
    numeric: false,
    disablePadding: false,
    label: 'Gerente',
  },
  {
    id: 'testemunha',
    numeric: false,
    disablePadding: false,
    label: 'Testemunha',
  },
  {
    id: 'categoria',
    numeric: false,
    disablePadding: false,
    label: 'Categoria',
  },
  { id: 'data', numeric: false, disablePadding: false, label: 'Data' },
  { id: 'valor', numeric: true, disablePadding: false, label: 'Valor' },
  { id: 'acoes', numeric: true, disablePadding: false, label: 'Ações' },
];

function EnhancedTableHead(props) {
  return (
    <TableHead>
      <TableRow style={{ backgroundColor: '#009FD4', color: 'white' }}>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            style={{ color: 'white' }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable({ rows = [], deleteHundle = () => {} }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
          >
            <EnhancedTableHead classes={classes} />
            <TableBody>
              {rows.map((row, index) => (
                <TableRow
                  role="checkbox"
                  tabIndex={-1}
                  key={row.id}
                  style={{
                    backgroundColor: row.isAcima ? '#91E395' : '#D66E66',
                  }}
                >
                  {/* <TableCell align="left">{row.funcionario}</TableCell> */}
                  <TableCell align="left">{row.gerente}</TableCell>
                  <TableCell align="left">{row.testemunha}</TableCell>
                  <TableCell align="left">{row.categoria}</TableCell>
                  <TableCell align="left">{row.data}</TableCell>
                  <TableCell align="right">{row.valor}</TableCell>
                  <TableCell align="right">
                    <Tooltip title="Excluir" aria-label="adicionar">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          deleteHundle({ id: row.id });
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
